import { createSelector } from '@reduxjs/toolkit';

import { Member } from '@paragon/contract-library';

import { getActiveComponent } from './getActiveComponentSelector';

export const getMemberRaycastType = createSelector(
  getActiveComponent,
  (component) => (member: Member) => (component && component.members.includes(member) ? 'member' : 'brace'),
);
